import BaseComponent from '../../../general/js/base-component';
import eventBus from '../../../general/js/event-bus';
import {EVENT_RESIZE_FINISHED} from '../../../general/js/app';
import onReady from './loadGmap';
import $ from 'jquery';
import '../img/circle.png';

export default class GmapComponent extends BaseComponent {

    constructor() {
        super(...arguments);

        this._markers = {
            pin: {},
            circle: {
                url: "/assets/dist/images/circle.png",
                width: 65,
                height: 65,
                centerX: 32,
                centerY: 32
            }
        };

        this.map = this.refs.map;
        this.marker = this.refs.marker;

        this.lat = $(this.marker).data('lat') || 0;
        this.lng = $(this.marker).data('lng') || 0;
        this.markerType = $(this.marker).data('marker') || 'pin';

        onReady(() => {
            this.init();
            eventBus.addListener(EVENT_RESIZE_FINISHED, () => {
                this.init();
            });
        });
    }

    static getRequiredRefs() {
        return ['map', 'marker'];
    }

    init() {

        let myLatLng = {
            lat: this.lat,
            lng: this.lng
        };

        // in case the map is inside the hidden block
        let parent = this.element.parentNode;
        let parentsHidden = [];

        while (parent.style) {
            if (parent.style.display === 'none') {
                parentsHidden.unshift(parent);
            }
            parent = parent.parentNode;
        }
        // make all hidden parent elements visible before map creating
        parentsHidden.forEach((currentElement) => {
            currentElement.classList.add('faux-hidden');
        });

        var zoom = $(this.map).data('zoom') || 11; // 11 is default zoom
        let map = new google.maps.Map(this.map, {
            zoom: zoom,
            center: myLatLng,
            disableDefaultUI: true
        });

        this.addMarker(map);

        // revert hidden parent elements
        google.maps.event.addListener(map, 'tilesloaded', () => {
            parentsHidden.forEach((currentElement) => {
                currentElement.classList.remove('faux-hidden');
            });
        });

    }

    addMarker(map) {
        let position = new google.maps.LatLng(this.lat, this.lng);
        let markerSettings = this._markers[this.markerType];
        let icon = {
            url: markerSettings.url,
            scaledSize: new google.maps.Size(markerSettings.width, markerSettings.height),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(markerSettings.centerX, markerSettings.centerY)
        };

        let marker = new google.maps.Marker({
            position: position,
            map: map,
            icon: icon,
            cursor: 'inherit'
        });
    }
}




// WEBPACK FOOTER //
// ./app/components/gmap/js/gmap.component.js